// extracted by mini-css-extract-plugin
export default {"cover":"PhotoCoverImage_cover__+RAFY dn db-m b-40"};